import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';
import {Subject}                from 'rxjs';

import StoreName              from '../../../../State/Shared/Constants/StoreName';
import Playback               from '../../../../State/Stores/Playback/Playback';
import * as TestIds           from '../../../Shared/Constants/TestIds';
import UiEventType            from '../../../Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../Shared/Interfaces/IUiEventsStreamPayload';
import composeTokenList       from '../../Util/composeTokenList';
import renderTestId           from '../../Util/renderTestId';
import * as styles            from '../PlaybackButtons/playbackButtons.css';

import IconPause from './Assets/IconPause';
import IconPlay  from './Assets/IconPlay';

interface IPlayPauseProps extends IConnectProps<Playback> {
    areControlsIdle: boolean;
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

@connect(StoreName.PLAYBACK)
class PlayPause extends React.Component<IPlayPauseProps> {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    public shouldComponentUpdate(nextProps: IPlayPauseProps): boolean {
        return (
            nextProps.value.playbackStatus !== this.props.value.playbackStatus ||
            nextProps.areControlsIdle !== this.props.areControlsIdle
        );
    }

    public render(): JSX.Element {
        const {isPlaying, isBuffering} = this.props.value;
        const Icon = isPlaying ? IconPause : IconPlay;

        const testIdBase: string = isPlaying ?
            TestIds.PLAYER_BUTTON_PAUSE : TestIds.PLAYER_BUTTON_PLAY;

        const testId = composeTokenList([
            testIdBase,
            [!this.props.areControlsIdle, testIdBase + '_VISIBLE']
        ]);

        if (isBuffering) return null;

        return (
            <button
                className={styles.playbackButton}
                onClick={this.handleClick}
                data-test-id={renderTestId(testId)}
            >
                <Icon/>
            </button>
        );
    }

    private handleClick(): void {
        this.props.uiEvents$.next({
            type: UiEventType.PLAY_PAUSE_TAP
        });
    }
}

export default PlayPause;